module.exports = __webpack_public_path__ + "static/media/Manual M4 WiLink 1.4b98e81d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Manual M4 WiLink 1.pdf
// module id = 321
// module chunks = 0